import { Form, Row, Col, Alert } from "react-bootstrap";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";
import LoginImg from "../../Imge/undraw_login_weas.svg";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { baseURL, FORGETPASSWORD } from "../../API/API";
import Lodingsubmit from "../../Components/Loding/Loding";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [success, SetSuccess] = useState("");

  function handelChange(e) {
    setEmail(e.target.value);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/${FORGETPASSWORD}`, { email });
      setLoading(false);
      setErr("");
      SetSuccess("");
      SetSuccess(res.data.message);
    } catch (err) {
      console.log(err);
      setLoading(false);
      setErr(err.response.data.Message);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && <Lodingsubmit />}
      <div className="Authpage">
        <Header />
        <Row className="w-100">
          <Col md={4} className="  imgform  d-none d-md-block p-0">
            <img
              src={LoginImg}
              alt="صورة تسجيل"
              className="img-fluid h-100 w-100"
              style={{ objectFit: "cover" }}
            />
          </Col>

          {/* الفورم على اليمين */}
          <Col
            xs={12}
            md={8}
            className=" form-contant d-flex align-items-center justify-content-center bg-light"
          >
            <Form className=" Form  w-75" onSubmit={handleSubmit}>
              <h3 className=" titleForm mb-4 text-strart">
                هل نسيت كلمة السر؟
              </h3>
              <p className=" mb-4 ">
                💬 ادخل بريدك الإلكتروني، وسيصلك رابط علي البريد الالكتروني
                الخاص بك لتتمكن من إعادة تعيين كلمة المرور.
              </p>

              <Form.Group className=" floating-label-group mb-4">
                <Form.Control
                  placeholder=" "
                  required
                  className="inpoutFeald"
                  type="email"
                  name="email"
                  value={email}
                  onChange={handelChange}
                />

                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faEnvelope} />
                  <span className="textinpout">البريد الإلكتروني</span>
                </Form.Label>
              </Form.Group>

              <button type="submit" className="btn_submit btn_small ms-auto">
                {loading ? "جاري الإرسال..." : "إرسال رابط إعادة التعيين"}
              </button>
              {err && (
                <Alert variant="danger" style={{ marginTop: "20px" }}>
                  ❌ {err}
                </Alert>
              )}

              {success && (
                <Alert variant="success" style={{ marginTop: "20px" }}>
                  ✅ {success}
                </Alert>
              )}

              <Link to="#" target="_blank" className="btn_square_green">
                طريقة انشاء حساب على نوح اكاديمي
              </Link>

              <div className=" mt-4">
                لا يوجد لديك حساب؟
                <Link to="/register" className="text-decoration-none">
                  <span className="gold"> انشئ حسابك الآن ! </span>
                </Link>
              </div>
            </Form>
          </Col>
        </Row>

        <Footer />
      </div>
    </>
  );
}
